import React from "react";
import { RATING_META } from "../../lib/inventorySkills";

// Whole-section rating (Tactical): Anchor / Good / Rate Limiter for a category as a whole. Saved in dev_assessments.category_ratings[category].
export function CategoryRating({ value, onChange, readOnly, testid, size = "sm" }) {
  const pad = size === "sm" ? "px-2 py-1 text-[8px]" : "px-2.5 py-1.5 text-[9px]";
  return (
    <div className="flex items-center gap-1" data-testid={testid} onClick={e => e.stopPropagation()}>
      {["anchor", "good", "limiter"].map(k => { const m = RATING_META[k]; const on = value === k; return (
        <button key={k} type="button" disabled={readOnly} onClick={() => onChange(on ? null : k)} title={`${m.label} — whole section`}
          className={`${pad} uppercase tracking-[0.2em] font-bold border transition-colors ${on ? "text-[#121212]" : "text-[#8a8a8a] border-white/10 hover:border-white/30 hover:text-white"} disabled:cursor-default`}
          style={on ? { background: m.color, borderColor: m.color } : undefined} data-testid={`${testid}-${k}`}>{m.short || m.label}</button>
      ); })}
    </div>
  );
}
